import { useMemo } from 'react';
import { useGet } from '../../../../api';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';

export type LatestApplicationsSyncDto = {
    max?: Date; // Use string if the API returns ISO date strings
};

export const useGetLastSync = () => {
    const { data, loading } = useGet<LatestApplicationsSyncDto>({
        url: `${ACCESS_ANALYSIS_BASE_URL}/applications/lastSync`
    });

    const lastSync = useMemo(() => {
        if (!data?.max) return null;

        return data.max;
    }, [data]);

    return { lastSync, lastSyncLoading: loading };
};
